<template>
  <v-col>
    <v-img
      :height="height"
      src="@/static/images/info/no-data-found.png"
      contain
    ></v-img>
    <div class="caption text-center grey--text" v-text="text"></div>
    <slot></slot>
  </v-col>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "No data available at the moment"
    },
    height: {
      type: [Number, String],
      default: 200
    }
  }
};
</script>
